/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "c1ce2694795806e6c9e282e45d69d6c0a49b11e6";
